export default __webpack_public_path__ + "static/media/SLIDE_CONCRECAM_1.1c848c94.jpg";